<nav aria-label="Bread Crumb Navigation">
    <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
        <li *ngFor="let bc of breadCrumbs">
                <a [routerLink]="bc.link">{{bc.name}}</a>
            </li>
    </bolt-breadcrumbs>
</nav>

<div class="page-indicator">
    <div class="claims-track-page-title-wrap claims-track-page-title--overview" *ngIf="claimsDataService.lossCauseTypesLoaded">
        Payments
        <small class="claims-track-company">
            <strong class="text-uppercase" *ngIf="lossCause">{{claimsDataService.getLossCause(claimInfo.lossCause)}}</strong>
            ({{claimInfo.claimNumber}})
            <strong class="text-uppercase">{{claimInfo.claimState}}</strong>
            <span *ngIf="claimInfo.incidentOnly">(Record Only)</span>
        </small>
        <small class="claims-track-number">Incident date: {{claimInfo.lossDate | date:'MM/dd/yyyy'}}</small>
    </div>
</div>

<div class="content-container-light-blue bolt-space-bottom-sm" *ngIf="!hasPayments && serviceFlag">
    <main class="content-container-light-blue__inner" role="main">
        <article class="claims-track-claim-content">
            <div class="claims-track-claim-content__text-box">
                <section class="claims-track-claim-estimates">
                    <div class="claims-track-claim-estimates__row margin-bottom-30">
                        <b>Total paid:</b> $0 (as of current date)
                    </div>
                    <div class="claims-track-claim-estimates__row" *ngIf="!legacyClaim">
                        Total paid may include additional indemnity and expense payments that may not be listed below.
                    </div>
                    <div class="claims-track-claim-estimates__row" *ngIf="legacyClaim">
                        Details for payments prior to {{legacyClaimCutoffDate | date: 'MMMM yyyy'}} are not available.
                        Please contact your claims
                        associate for details.
                    </div>
                </section>
            </div>
        </article>
    </main>
</div>

<div class="content-container-light-blue bolt-space-bottom-sm" *ngIf="hasPayments">
    <main class="content-container-light-blue__inner" role="main">
        <section class="claims-track-claim-estimates" *ngIf="legacyClaim">
            <div class="claims-track-claim-estimates__row">
                Details for payments prior to {{legacyClaimCutoffDate | date: 'MMMM yyyy'}} are not available. Please
                contact your claims
                associate for details.
            </div>
        </section>

        <article class="claims-track-claim-content">
            <h2>Payment Summary</h2>
            <div class="claims-track-claim-content__text-box">
                <section class="claims-track-claim-estimates">
                    <div class="claims-track-claim-estimates__row">
                        <b>Total paid:</b> {{totalPayments}} (as of current date)
                    </div>
                    <div class="claims-track-claim-estimates__row">&nbsp;</div>
                    <div class="claims-track-claim-estimates__row">
                        Total paid may include additional indemnity and expense payments that may not be listed below.
                    </div>
                </section>
            </div>
        </article>

        <article class="claims-track-claim-content">
            <h2>Payment History</h2>

            <div class="claims-track-claim-content__text-box" style="padding-bottom: 15px" *ngFor="let payment of displayPayments">
                <h3 class="border-bottom-gray margin-bottom-0">Payment to {{payment.payee | uppercase}}</h3>

                <section class="claims-track-claim-estimates">
                    <div class="claims-track-claim-estimates__row">
                        <div>Issued Date:</div>
                        <div>{{payment.issueDate | date:'MMMM dd, yyyy'}}</div>
                    </div>
                    <div class="claims-track-claim-estimates__row">
                        <div>Amount:</div>
                        <div>{{payment.paymentAmount}}</div>
                    </div>
                    <div class="claims-track-claim-estimates__row">
                        <div>Payment Method:</div>
                        <div>{{payment.paymentMethod}}</div>
                    </div>
                    <div class="claims-track-claim-estimates__row">
                        <div>Check/Reference number:</div>
                        <div>{{payment.referenceNumber}}</div>
                    </div>
                    <div class="claims-track-claim-estimates__row">
                        <div>Status:</div>
                        <div>{{payment.displayName}}</div>
                    </div>
                </section>
            </div>

            <div class="text-right" *ngIf="hasMore">
                <button id="showMore" class="btn btn-default button-right button-margin margin-bottom-30" (click)="showMore()">View more</button>
            </div>

        </article>

        <article class="claims-track-claim-content note-section-fix">
            <div class="claims-track-claim-content__text-box">
                <h3 class="bold margin-bottom-0 margin-top-10">Note</h3>
                <p class="note-fix">
                    <small>
                        Claims payments are usually made via check by mail. If you'd prefer to get your payment via an
                        Electronic Funds Transfer
                        (EFT) to your account, please inform your Nationwide claims associate.
                    </small>
                </p>

                <p class="note-fix" *ngIf="!isWorkersComp">
                    <small>If there were any injuries, please contact your assigned claims representative for
                        information about any injury
                        related details and payments.</small>
                </p>
            </div>
        </article>
    </main>
</div>

<nav aria-label="Bread Crumb Navigation">
    <bolt-breadcrumbs class="bolt-space-bottom-sm" currentleveltext="{{currentPage}}" iconlink="{{homeIconLink}}">
        <li *ngFor="let bc of breadCrumbs">
                <a [routerLink]="bc.link">{{bc.name}}</a>
            </li>
    </bolt-breadcrumbs>
</nav>
